// src/moment/components/WordOfTheDay/WordOfTheDay.tsx

import { FC } from 'react';
import './WordOfTheDay.scss';

// Props are now more flexible. Some are optional to gracefully handle
// variations in API data.
export interface WordOfTheDayProps {
  header: string;
  word: string;
  definition: string;
  // Optional props
  pronunciation?: string;
  wordType?: string;
  contextTitle?: string;
  context?: string;
  showHeader?: boolean;
}

const WordOfTheDay: FC<WordOfTheDayProps> = ({
                                               header,
                                               word,
                                               pronunciation,
                                               wordType,
                                               definition,
                                               contextTitle,
                                               context,
                                               showHeader = true
                                             }) => {
  return (
    <div className="word-of-the-day">
      {showHeader && <h3 className="word-of-the-day__header header-md">{header}</h3>}

      <div className="word-of-the-day__content">
        <div className="word-of-the-day__main-info">
          <span className="word-of-the-day__word">{word}</span>
          {/* Conditionally render the type/pronunciation line if data exists */}
          {(wordType || pronunciation) && (
            <span className="word-of-the-day__type">
              {wordType}
              {wordType && pronunciation && ' | '}
              {pronunciation}
            </span>
          )}
        </div>

        <p className="word-of-the-day__definition">{definition}</p>

        {/* Conditionally render the context block if context exists */}
        {context && contextTitle && (
          <div className="word-of-the-day__context-block">
            <h4 className="word-of-the-day__context-title">{contextTitle}</h4>
            <blockquote className="word-of-the-day__context">
              "{context}"
            </blockquote>
          </div>
        )}
      </div>
    </div>
  );
};

export default WordOfTheDay;
